import React from 'react';
import { ButtonProps, ButtonTemplate } from './button';

const GoogleIcon = React.lazy(() => import('@cp/ds/src/icons/social/google').then((m) => ({ default: m.GoogleIcon })));

export const GoogleButton = (props: ButtonProps) => {
  const [loading, setLoading] = React.useState(false);
  return (
    <ButtonTemplate
      loading={loading}
      {...props}
      onClick={(e) => {
        setLoading(true);
        props.onClick?.(e);
      }}
    >
      <GoogleIcon /> Продолжить с Google
    </ButtonTemplate>
  );
};
